export function getDomain() {

        const host = window.location.host
        const hostParts = host.split('.')

        let domain
        if(hostParts[0] == "docker") {
            domain = hostParts[1]
        } else {
            // TODO : hostParts[0] dans le cas de la prod
            domain = hostParts[0]
        }

        return domain
}
